<template>
  <div class="w-100 bg-white min-vh-100">
    <Navbar />
    <block :height="83"></block>
    <div class="ga-container d-block pb-5">
      <div v-if="cartContext.is_load" class="w-100 py-4">
        <loader />
      </div>
      <template v-else>
        <div class="w-100 pt-4" v-if="cartContext.error != ''">
          <ErrorMessage :message="cartContext.error" />
        </div>
        <div v-else class="w-100">
          <div class="row">
            
            <!-- MAIN CONTENT -->
            <div class="col-xl-8 col-lg-7 col-md-12 order-lg-1 order-2">
              <template v-if="!cartContext.payment_in_page">
                <!-- ADD MENU BUTTON REMOVED (Moved to Sidebar) -->

                <!-- GUEST INFORMATION -->
                <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-4" id="middle_section">
                  <p class="mb-1 heading-6-1">Personalize Your Order, Note by Note!</p>
                  <p class="mb-4 body-3-3-1">Add your name, table number, and special requests for a perfect meal!</p>
                  <GuestForm ref="order_guest_form" type="ORDER" :is-contact-required="cartContext.need_guest_data_for_payment"  />
                </div>

                <!-- SERVE OPTION (IF DELIVERY AVAILABLE) -->
                <template v-if="cartContext.general_data.use_delivery">
                  <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-4">
                    <p class="mb-1 heading-6-1">Choose Your Dining Preference</p>
                    <p class="mb-4 body-3-3-1">Indicate whether you prefer delivery or on-site dining.</p>
                    
                    <div class="w-100 pt-2">
                      <div class="row slim-grid-row">
                        <div class="col-6 mb-3" v-for="(serve,serve_i) in cartContext.serve_option.list" :key="serve.id">
                          <div class="w-100 h-100 radius-6 cursor-pointer position-relative" :id="serve.id" @click="cartContext.serveOptionSelect(serve)" :class="serve.id != cartContext.serve_option.selected.id ? 'border-form' : 'border-2-green'">
                            <div class="d-flex align-items-center py-2 z-index-1026">
                              <div class="px-3 text-center">
                                <svg v-if="serve.id != cartContext.serve_option.selected.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                                    fill="#222222" />
                                </svg>
                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                                </svg>
                              </div>
                              <div>
                                <div class="w-100 pr-3">
                                  <p class="mb-0 body-2-1" :class="{'text-green': serve.id == cartContext.serve_option.selected.id}">{{ serve.title }}</p>
                                  <p class="mb-0 body-3-3-1" :class="{'text-green': serve.id == cartContext.serve_option.selected.id}">{{ serve.subtitle }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- DELIVERY INFORMATION -->
                  <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-4" v-if="cartContext.serve_option.selected.id == 'delivery'">
                    <p class="mb-1 heading-6-1">Ensure Your Order Reaches You!</p>
                    <p class="mb-4 body-3-3-1">Provide your delivery address for a seamless experience.</p>
                    <p class="mb-3 body-2 text-danger" v-if="cartContext.serve_option.error != ''">{{ cartContext.serve_option.error }}</p>
                    <Delivery ref="delivery_section" page_module="CUSTOM_POS" :pos_id="cartContext.general_data.id" />
                  </div>
                </template>

                <!-- PAYMENT -->
                <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
                  <template v-if="!cartContext.getOutletTrxDelivery.use">
                    <template v-if="cartContext.general_data.payment_mode == 'PAY_LATER'">
                      <p class="mb-1 heading-6-1">Payment</p>
                      <p class="mb-4 body-3-3-1">Enjoy your meal now, settle the bill later.</p>
                    </template>
                    <template v-if="cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">
                      <p class="mb-1 heading-6-1">Payment Options</p>
                      <p class="mb-4 body-3-3-1">Choose how you'd like to settle.</p>
                      
                      <div class="row pt-2">
                        <div class="col-xl-6 col-12 mb-xl-0 mb-3" v-for="(p_mode,p_mode_i) in cartContext.payment_mode.list" :key="p_mode.id">
                          <div class="w-100 radius-6 cursor-pointer" :id="p_mode.id" @click="cartContext.paymentModeSelect(p_mode)" :class="p_mode.id != cartContext.payment_mode.data.id ? 'border-form' : 'border-2-green'">
                            <div class="row no-gutters align-items-center py-2 h-100">
                              <div class="col-2 text-center">
                                <svg v-if="p_mode.id != cartContext.payment_mode.data.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                                    fill="#222222" />
                                </svg>
                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                                </svg>
                              </div>
                              <div class="col-10">
                                <div class="w-100 pr-3">
                                  <p class="mb-0 body-2-1" :class="{'text-green': p_mode.id == cartContext.payment_mode.data.id}">{{ p_mode.title }}</p>
                                  <p class="mb-0 body-3-3-1" :class="{'text-green': p_mode.id == cartContext.payment_mode.data.id}">{{ p_mode.description }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class="mb-0 mt-2 body-2 text-danger" v-if="cartContext.validate_payment.mode">Please select payment option</p>
                    </template>
                  </template>

                  <!-- PAYMENT METHOD -->
                  <div class="w-100" :class="{'mt-4 pt-4 border-t-semi-grey-dashed-2' : !cartContext.getOutletTrxDelivery.use && cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && cartContext.payment_mode.data.id == 'PAY_IMMEDIATELY'}" v-if="cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY' || (cartContext.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && cartContext.payment_mode.data.id == 'PAY_IMMEDIATELY')">
                    <p class="mb-1 heading-6-1">Payment Method</p>
                    <p class="mb-4 body-3-3-1">Choose your preferred way to pay securely.</p>
                    <div class="w-100">
                      <PaymentMethod ref="payment_method" module="concierge" :sub_module="cartContext.general_data.code" @selectPayment="cartContext.selectPayment" @doneLoad="cartContext.paymentMethodDoneLoad"></PaymentMethod>
                    </div>
                  </div>
                </div>

                <!-- SUBMIT BUTTON -->
                <div class="w-100 d-lg-block d-none">
                  <div class="w-100 mb-4" v-if="cartContext.error_push != ''">
                    <ErrorMessage :message="cartContext.error_push" />
                  </div>
                  
                  <state-button variant="secondary" size="xl" block :click="cartContext.submitForm">Place Order</state-button>
                </div>
              </template>

              <!-- XENDIT CC -->
              <div v-else class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
                <XenditCardPayment
                  :tx_payment="cartContext.tx_payment"
                  module_page="CONCIERGE"
                  submodule_page="CUSTOM_POS"
                  @done="cartContext.clearCart"
                  @expired="cartContext.goToHomepage">
                </XenditCardPayment>
              </div>
            </div>

            <!-- SIDERBAR SUMMARY (Right side) -->
            <div class="col-xl-4 col-lg-5 col-md-12 order-lg-2 order-1 mb-lg-0 mb-5">
              <div class="general-booking-summary sticky-top" style="top: 100px;">
                <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey overflow-hidden">
                  <div class="p-4 bg-top-black">
                    <p class="mb-0 body-2-2 font-semibold text-16 text-white">Order Summary</p>
                    <p class="mb-0 body-2-2 font-bold text-20 text-white">{{ cartContext.getMerchant.name }}</p>
                  </div>
                  <div class="px-4 pt-4 border-b-semi-grey">
                    <!-- PRODUCT LIST -->
                    <div class="w-100 mb-2" v-for="(product,product_i) in cartContext.getOutletTrxProducts" :key="product_i">
                      <ProductCart :data="product" :product_index="product_i" />
                    </div>
                    
                    <!-- ADD MORE BUTTON -->
                    <div class="w-100 mb-4 mt-3" id="add_menu_section" v-if="!cartContext.tx_inquiry.id">
                      <button class="g-btn g-btn-primary-outline g-btn-sm w-100 d-flex align-items-center justify-content-center" @click="cartContext.goToPage('PosHome')" style="border-style: dashed; padding-top: 10px; padding-bottom: 10px;">
                        <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                        Add more item
                      </button>
                    </div>
                  </div>

                  <div class="p-4 border-b-semi-grey" v-if="!cartContext.tx_inquiry.id">
                    <PromoCode :general_data="cartContext.general_data" />
                  </div>
                  
                  <div class="w-100 p-4">
                    <div class="row mb-2">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Subtotal</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0">{{ $formatCurrency(cartContext.getOutletTrxSubTotal) }}</p>
                      </div>
                    </div>
                    <div class="row mb-2" v-if="cartContext.getOutletTrxTaxService > 0">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Tax &amp; Service</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0">{{ $formatCurrency(cartContext.getOutletTrxTaxService) }}</p>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Discount</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0" :class="{'text-orange': cartContext.getOutletTrxPromotion > 0}">{{cartContext.getOutletTrxPromotion > 0? '-' : ''}}{{ $formatCurrency(cartContext.getOutletTrxPromotion) }}</p>
                      </div>
                    </div>
                    <div class="row mb-2" v-if="cartContext.getOutletTrxDelivery.use && cartContext.serve_option.selected.id == 'delivery'">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Delivery Fee</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0">{{ cartContext.getOutletTrxDelivery.inquiry.delivery_fee ? $formatCurrency(cartContext.getOutletTrxDelivery.inquiry.delivery_fee) : '0' }}</p>
                      </div>
                    </div>
                    <div class="row mb-2" v-if="cartContext.payment_surcharge > 0">
                      <div class="col-6">
                        <p class="mb-0 body-2-4">Payment Surcharge</p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="text-14 font-lato mb-0">{{ $formatCurrency(cartContext.payment_surcharge) }}</p>
                      </div>
                    </div>
                    <!-- Total -->
                    <div class="row mt-3">
                      <div class="col-4">
                        <p class="mb-0 body-1-4">Total</p>
                      </div>
                      <div class="col-8 text-right">
                        <p class="text-16 font-lato mb-0">{{ $formatCurrency(cartContext.total_price) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- MOBILE SUBMIT BUTTON FIXED BOTTOM IF NEEDED -->
            <div class="w-100 position-sticky bg-white border-form py-3 z-index-1040 d-lg-none d-block" style="bottom: 0px;" v-if="!cartContext.payment_in_page">
              <div class="ga-container">
                <div class="row slim-grid-row mb-2">
                  <div class="col-12 mb-2 text-center" v-if="cartContext.error_push != ''">
                    <p class="mb-0 body-2 text-danger">Error : {{ cartContext.error_push }}</p>
                  </div>
                  <div class="col-6">
                    <p class="mb-0 body-1-4">Total</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 font-lato text-16">{{ $formatCurrency(cartContext.total_price) }}</p>
                  </div>
                </div>
                <state-button variant="primary" size="xl" block :click="cartContext.submitForm">Place Order</state-button>
              </div>
            </div>

          </div>
        </div>
      </template>
    </div>
    <Footer />
    
    <b-modal
      v-model="cartContext.product_detail_popup.show"
      centered size="md" hide-header hide-footer body-class="p-0 overflow-hidden">
      <div class="w-100" v-if="cartContext.product_detail_popup.show">
        <ProductDetail 
          page_module="outlet" 
          :detail_data="{ pos_id: cartContext.product_detail_popup.pos_id, product_id: cartContext.product_detail_popup.product_id }" 
          @close="cartContext.product_detail_popup.show = false" />
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Navbar from '@/components/hotel/concierge/general/Navbar';
  import Footer from '@/components/hotel/concierge/general/Footer';
  import ProductCart from '@/components/hotel/concierge/pos/ProductCart';
  import GuestForm from '@/components/hotel/concierge/pos/GuestForm';
  import PromoCode from '@/components/hotel/concierge/pos/PromoCode.vue';
  import PaymentMethod from '@/components/general/payment/PaymentMethod';
  import XenditCardPayment from '@/components/v2/XenditCardPayment';
  import Delivery from "@/components/general/Delivery";
  import ProductDetail from '@/pages/hotel/concierge/pos/ProductDetail';

  export default {
    components:{
      Navbar,
      Footer,
      ProductCart,
      GuestForm,
      PromoCode,
      PaymentMethod,
      XenditCardPayment,
      Delivery,
      ProductDetail
    },
    inject: ['cartContext'],
    methods: {
      validateOrderGuestForm() {
        return this.$refs.order_guest_form.validateForm()
      },
      toggleDelivery() {
        if (this.$refs.delivery_section) {
          this.$refs.delivery_section.toggleDelivery()
        }
      },
      validatePaymentMethod() {
        return this.$refs.payment_method.validateForm()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/layouts/CartWideLayout.vue